/* tslint:disable */
/* eslint-disable */

/**
 * Customer's Address Type. Can be:
 *   * Home
 *   * Work
 *   * School
 *   * Other
 */
export enum AddressType {
  Home = 'Home',
  Work = 'Work',
  School = 'School',
  Other = 'Other'
}
